// Single authoritative source for the RC server base URL.
// Throws at call time if the env var is missing or (in production) non-HTTPS,
// so misconfigured deployments fail loudly rather than silently sending auth
// tokens to the wrong host.
export function getRcBaseUrl(): string {
  const raw = import.meta.env.VITE_APP_CHAT_SOURCE_URL as string | undefined;
  if (!raw) {
    throw new Error('VITE_APP_CHAT_SOURCE_URL is not configured');
  }
  const url = raw.replace(/\/+$/, '');
  if (import.meta.env.PROD && !url.startsWith('https://')) {
    throw new Error(`RC server URL must use HTTPS in production (got: ${url})`);
  }
  return url;
}
